module.exports = __webpack_public_path__ + "img/贡献2.4c5e83ff.png";